<template>
    <div>
        <div class="sa-noti-scroll">
            <ul class="sa-notific-list">
                <li v-for="(item, i) in notificationList" :key="i" :style="{'background-color':item.color}">
                    <div class="sa-noti-cont" :class="item.uc_id ? '':'sa-noti-offers'" @click="reDirect(item)">
                        <i class="sa-noti-icon" :class="item.icon_class"></i>
                        <small class="sa-noti-tim">{{ time(item.time) }}</small>
                        <p v-if="item.title">{{item.gc_id? item.title.en : item.title}}</p>
                        <div class="sa-noti-cont-img">
                            <p v-if="item.message" :class="item.featured_img?'sa-ftr-img':''">
                                <span v-html="item.gc_id ? item.message.en : item.message"></span>
                            </p>
                            <figure v-if="item.featured_img" class="sa-avtar sa-avtar-md">
                                <img :src="item.featured_img" alt="avtar" class="sa-img-cover" />
                            </figure>
                        </div>
                        <figure v-if="item.banner_img" class="sa-offer-img">
                            <img :src="item.banner_img" alt="avtar" class="sa-img-cover" />
                        </figure>
                    </div>
                </li>
                <!-- <li v-if="notificationList && notificationImg && !notificationList.length" class="notific-img">
                    <img :src="notificationImg" alt="notification image" class="sa-img-cover">
                </li> -->
                <!-- <div v-if="notificationList && !notificationList.length" style="text-align: center;">{{notificationMsg}}
                </div> -->
                <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler"
                    spinner="waveDots"></infinite-loading>
            </ul>
        </div>


    </div>
</template>

<script>
    import API from '../../services/api';
    import InfiniteLoading from "vue-infinite-loading";
    import moment from "moment"
    export default {
        props: ['filterObj'],
        components: {
            "infinite-loading": InfiniteLoading,
        },
        data() {
            return {
                toggle: false,
                receivedCount: 0,
                messages: [],
                page: 1,
                infiniteId: "",
                pageLimit: 10,
                notificationList: [],
                notificationImg: '',
                notificationMsg: '',
                count: 0
            }
        },
        created() {
            // this.getNotifications(false);
            let self = this
            // self.getNotifyCount()
            self.getNotifications()
        },
        methods: {
            changeTab() {
                this.tabSelection = true;

            },
            open() {
                this.aflag = true
            },
            close() {
                this.aflag = false
            },
            time(val) {
                return moment(val).fromNow(true)
            },
            reDirect(val) {
                if (!val.rd_sts) {
                    let req = {
                        tid: val.tid
                    }
                    API.updateNotification(req, function (response) {
                        if (response && response.status === 1000) {
                            if (val.redir_url) {
                                window.open(val.redir_url, '_blank')
                            } else if (val.payload.uc_url) {
                                window.open(val.payload.uc_url, '_blank')
                            }
                        }
                    })
                } else {
                    if (val.redir_url) {
                        window.open(val.redir_url, '_blank')
                    } else if (val.payload.uc_url) {
                        window.open(val.payload.uc_url, '_blank')
                    }
                }
            },
            infiniteHandler(e) {
                this.getNotifications(e)
            },
            getNotifications(e) {
                let _self = this;
                let request = {
                    page: _self.page,
                }
                if (_self.filterObj) {
                    request.page = _self.page
                    request.cls_code = _self.filterObj.cls_code
                    request.time = _self.filterObj.time
                    request.action = _self.filterObj.action
                }

                API.getNotifications(request, function (response) {
                    if (response && response.status === 1000) {
                        _self.count = response.data.all_count
                        _self.$emit('allCountEvent', _self.count)
                        _self.$emit('serviceReqEvent', response.data.service_request_count)
                        // _self.notificationList = response.data.notification
                        _self.notificationList.push.apply(_self.notificationList, response.data.notification);
                        _self.notificationMsg = response.message
                        _self.notificationImg = (response && response.data && response.data.image_url) ? response.data.image_url : ''
                        if (e) {
                            console.log('response.data.metadata', response.data.metadata);
                            if (response.data.metadata[0].page >= response.data.metadata[0].total_pages) {
                                e.complete();
                            } else {
                                e.loaded();
                            }
                        }
                        _self.page += 1;
                        // _self.receivedCount = response.data['receivedCount'];
                        // if (response.data.messages && response.data.messages.length) {
                        //     if (_self.page == 1) {

                        //     }                        
                        //     _self.page += 1
                        //     _self.messages.push.apply(_self.messages, response.data.messages);
                        //     e.loaded();
                        //     if (e === true) {
                        //         let dataToAck = {
                        //             ids: []
                        //         };
                        //         _self.messages.filter(ele => {
                        //             if (ele.RECEIVED_STATUS == false) {
                        //                 dataToAck.ids.push(ele['_id'])
                        //             }
                        //         });
                        //         if (dataToAck.ids.length) {
                        //             _self.receivedCount = 0;
                        //             _self.$root.$emit('acknowledge', dataToAck);
                        //         }
                        //     }

                        // } else {
                        //     if (e) {
                        //         e.complete();
                        //     }
                        // }
                    } else {
                        if (e) {
                            e.complete();
                        }
                    }
                });
            },
            handleRead(id, readStatus) {
                let _self = this;
                let dataToRead = {
                    ids: [id]
                };
                if (!readStatus) {
                    _self.$root.$emit('notifyRead', dataToRead);
                }
            },
            // getNotifyCount() {
            //     console.log('notify')
            //     let self = this
            //     API.getNotifyCount(function (response) {
            //         console.log('count res', response)
            //         if (response && response.status === 1000) {
            //             self.receivedCount = response.data.count
            //         }
            //     })
            // }
        },
        computed: {
            inAppNotification() {
                return this.$store.getters["common/getInAppNotification"]
            }
        },
        watch: {
            inAppNotification() {
                if (this.inAppNotification) {
                    this.count = this.count + 1
                    this.$emit('allCountEvent', this.count)
                    this.$emit('serviceReqEvent', this.count)
                    // this.$store.dispatch('common/SET_NOTIFY_COUNT', ncount)
                    this.notificationList.splice(0, 0, this.inAppNotification)

                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/notification/AllNotifications.vue